import { render, staticRenderFns } from "./ServerImage.vue?vue&type=template&id=15664866&scoped=true&"
import script from "./ServerImage.vue?vue&type=script&lang=js&"
export * from "./ServerImage.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/document_thumbnails.scss?vue&type=style&index=0&id=15664866&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15664866",
  null
  
)

export default component.exports